import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import { currentAppDefinitionEntity } from 'app/developer-v3/selectors';
import {
  selectAppId,
  selectDefinitionOverride,
  selectVersionNumber,
} from 'app/developer-v3/store/selectors';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as Profile from 'app/entities/Profile';

import Advanced from './AdvancedPage';

const mapStateToProps = state => {
  const appId = selectAppId(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const isLoading = CliApp.selectors.all.isLoadingById(appId, state);

  const appDefinitionEntity = currentAppDefinitionEntity(state);

  const isGUIIntegration =
    !isLoading &&
    CliAppDefinition.selectors.isGUIIntegration(appDefinitionEntity);

  return {
    appId,
    currentUrl: RouterSelectors.currentUrl(state) || '',
    hasLegacy: !!selectDefinitionOverride(state).legacy,
    isStaff: Profile.selectors.isStaff(currentProfile),
    isGUIIntegration,
    version: selectVersionNumber(state),
  };
};

export default connect(mapStateToProps)(Advanced);
